import styled from 'styled-components';

export const Container = styled('div')`
  display: flex;
  display: -webkit-flex;
  height: -webkit-fill-available;
  justify-content: center;
  align-items: center;
  flex: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;
